'use client';
import { Box, Divider } from '@mui/material';
import BlogDetailsSection from '@/components/sections/BlogDetails/BlogDetailsSection';
import ScrollProgress from '@/components/common/ScrollProgress';
import PreviousAndNext from '@/components/sections/BlogDetails/PreviousAndNext';
import Comments from '@/components/comments';

const ShowBlog = ({ params, blog: data }) => {
  const shortId = params.id;

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          zIndex: 1100,
        }}>
        <ScrollProgress />
      </Box>
      <Box pt={5}>
        <BlogDetailsSection blog={data} blogId={shortId} />
      </Box>
      <Divider sx={{ my: 10 }} />
      <PreviousAndNext shortId={shortId} data={data} />
      <Divider />
      <Box sx={{ my: 5 }}>
        <Comments type="blog" id={data?._id} blogOwner={data?.isOwner} />
      </Box>
    </>
  );
};

export default ShowBlog;
